import {initEERepoSettingsPathRulesForm} from './ee-repo-settings-path-rules.ts';

export function initOrgSettingBranches() {
  const branchesSection = document.querySelector('.organization.settings.branches');
  if (!branchesSection) return;

  initEERepoSettingsPathRulesForm(); // the path rules section is shared with the repo-level page

  for (const element of document.querySelectorAll('.toggle-target-enabled')) {
    element.addEventListener('change', (event) => {
      const targetSelector = (event.currentTarget as HTMLElement).getAttribute('data-target');
      if (!targetSelector) return;
      const target = document.querySelector(targetSelector);
      if (target) {
        target.classList.toggle('disabled', !(event.currentTarget as HTMLInputElement).checked);
      }
    });
  }

  for (const element of document.querySelectorAll('.toggle-target-disabled')) {
    element.addEventListener('change', (event) => {
      const targetSelector = (event.currentTarget as HTMLElement).getAttribute('data-target');
      if (!targetSelector) return;
      const target = document.querySelector(targetSelector);
      if (target && (event.currentTarget as HTMLInputElement).checked) {
        target.classList.add('disabled'); // only disable, do not auto enable
      }
    });
  }

  const forceInheritanceBox = document.querySelector('#force_inheritance_box');
  if (forceInheritanceBox) {
    forceInheritanceBox.addEventListener('change', () => {
      const form = document.querySelector('#force_inheritance_form');
      if (form) {
        (form as HTMLFormElement).submit();
      }
    });
  }
}
